import { gql } from "@apollo/client";

export default gql`
  query inspectCollection($data: InspectCollectionInput!){
    inspectCollection(data: $data){
        success
        data{
            collection
            counts{
                key
                count
            }
            indexes{
                name
                keys
                unique
            }
            samples
            estimatedTotal
        }
        code
        message
    }
}
`
